import React, { useContext, useEffect, useState } from "react";
import { Alert, Card } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserContext } from "context/User/UserContext";

export function SubjectIndex(props) {
  const [randomization, setRandomization] = useState(null);
  const [error, setError] = useState({ state: false, message: "" });
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!("randomization" in user) || user.randomization == null)
        setError({
          state: true,
          message: "Randomization is not set. Please contact the study staff",
        });
      else setRandomization(user.randomization.toLowerCase());
    })();
  }, []);

  useEffect(() => {
    if (randomization === "edu")
      navigate(process.env.PUBLIC_URL + "/subject/edu/modules");
    else if (randomization === "hrvb")
      navigate(process.env.PUBLIC_URL + "/subject/hrvb/modules");
  }, [randomization]);

  if (error.state) {
    return (
      <>
        <Alert variant="danger" className="my-3">
          <strong>Error:</strong> {error.message}
        </Alert>
      </>
    );
  }

  return (
    <div
      className="d-flex justify-content-center gap-3 flex-wrap"
      style={{ minHeight: "inherit" }}
    >
      Welcome! Select the module you want to access
    </div>
  );
}
